import { useParams } from "common/components/Form/ParamsContext";
import { getEmailTemplateService } from "./emailTemplateApi";

export default function useEmailTemplateList() {
  const params = useParams();
  const scope = undefined;
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0
      ? "email-templates/"
      : ""
  }`;
  const service = getEmailTemplateService();

  return { ...service, params, scope, editUrl };
}
